import Countdown from 'react-countdown'
import { useTranslation } from 'react-i18next'
import { StyledClockWrapper, StyledIcon } from './styled'
import { Props } from './types'
import IconTimer from '~/assets/images/timer.svg'

const Clock: React.FC<Props> = ({ targetDate }) => {
  const { t } = useTranslation()

  const renderCountDown = ({ days, hours, minutes, seconds }) => {
    return (
      <div>
        <span>{days}</span>
        <b>{t('days')}</b>
        <span>{hours}</span>
        <b>:</b>
        <span>{minutes}</span>
        <b>:</b>
        <span>{seconds}</span>
      </div>
    )
  }

  return (
    <StyledClockWrapper className="trade-mining-clock">
      <StyledIcon src={IconTimer} />
      {!!targetDate && (
        <Countdown date={targetDate} renderer={renderCountDown} />
      )}
    </StyledClockWrapper>
  )
}

export default Clock
